export default __webpack_public_path__ + "static/media/sleep.738ac9cd.jpg";